import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { APP_PATHS, PAGE_PATHS } from '../../../../../types';
import { defaultFilters } from '../../../../../views/Remediation/remediation.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/remediation/')({
  validateSearch: zodValidator(withDefaults(schema.REMEDIATION, defaultFilter, defaultFilters)),
  search: {
    middlewares: [stripSearchParams({ ...defaultFilter, ...defaultFilters })],
  },
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({
      app: APP_PATHS.VULNERABILITIES,
      path: PAGE_PATHS.REMEDIATION,
    });
    context.validatePermissions({ isAllowed, preload });
  },
});
